import { CommonProductQueryParams } from '~/api/easy-estimator-api/commonProductQueryParams';
import { easyEstimatorApi } from '~/api/easy-estimator-api/easyEstimatorService';
import { ApiUrl } from '~/core/enums';
import { ApplianceModel } from '~/core/models';

const sinksApi = easyEstimatorApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchSinks: builder.query<ApplianceModel[], CommonProductQueryParams>({
      query: ({ params }) => ({
        url: ApiUrl.SINKS,
        method: 'GET',
        params,
      }),
    }),
    fetchCustomerSuppliedSinks: builder.query<
      ApplianceModel[],
      CommonProductQueryParams
    >({
      query: ({ params }) => ({
        url: ApiUrl.CUSTOMER_SUPPLIED_SINKS,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useFetchSinksQuery,
  useLazyFetchSinksQuery,
  useFetchCustomerSuppliedSinksQuery,
  useLazyFetchCustomerSuppliedSinksQuery,
} = sinksApi;
